import { SxProps, Theme } from "@mui/material";

export const pageWrapper: SxProps<Theme> = {
  bgcolor: "#040922",
  pt: "140px",
  pb: "120px",
  position: "relative",
  overflow: "hidden",
};

export const radialGlow: SxProps<Theme> = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "900px",
  height: "900px",
  borderRadius: "50%",
  background:
    "radial-gradient(ellipse at center, rgba(56,189,248,0.09) 0%, rgba(32,100,220,0.06) 35%, transparent 70%)",
  pointerEvents: "none",
};

export const gradientText: SxProps<Theme> = {
  background: "linear-gradient(90deg, #3b82f6 0%, #38bdf8 60%, #67e8f9 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
};

export const eyebrow: SxProps<Theme> = {
  background: "linear-gradient(90deg, #3b82f6 0%, #38bdf8 60%, #67e8f9 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
  fontFamily: "'Barlow', sans-serif",
  letterSpacing: "0.15em",
  fontSize: "0.75rem",
  fontWeight: 700,
  display: "block",
  mb: 2,
};

export const heading: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  color: "#ffffff",
  fontSize: { xs: "2.5rem", md: "3.5rem" },
  mb: 3,
};

export const subtitle: SxProps<Theme> = {
  color: "rgba(255,255,255,0.82)",
  fontSize: "1.125rem",
  whiteSpace: { xs: "normal", md: "nowrap" },
  mx: "auto",
};

export const glassTableContainer: SxProps<Theme> = {
  bgcolor: "rgba(5,12,35,0.5)",
  backdropFilter: "blur(16px)",
  WebkitBackdropFilter: "blur(16px)",
  border: "1px solid rgba(56,189,248,0.18)",
  borderRadius: "20px",
  boxShadow: "0 8px 40px rgba(10,15,30,0.4), 0 0 60px rgba(56,189,248,0.1)",
  overflow: "hidden",
};

export const tableHeaderRow: SxProps<Theme> = {
  bgcolor: "rgba(56,189,248,0.08)",
  borderBottom: "1px solid rgba(56,189,248,0.15)",
};

export const tableHeaderCell: SxProps<Theme> = {
  color: "#ffffff",
  fontWeight: 700,
  fontFamily: "'Barlow', sans-serif",
  fontSize: "0.9rem",
  borderBottom: "1px solid rgba(56,189,248,0.15)",
  py: 2.5,
  px: 3,
};

export const tableCell: SxProps<Theme> = {
  color: "rgba(255,255,255,0.82)",
  borderBottom: "1px solid rgba(255,255,255,0.06)",
  fontFamily: "'Barlow', sans-serif",
  py: 2,
  px: 3,
};

export const footerNote: SxProps<Theme> = {
  color: "rgba(255,255,255,0.5)",
  textAlign: "center",
  whiteSpace: { xs: "normal", md: "nowrap" },
  mt: 4,
  fontSize: "0.8rem",
  lineHeight: 1.6,
  px: { xs: 2, md: 0 },
};

export const supportEmailLink: SxProps<Theme> = {
  color: "rgba(56,189,248,0.8)",
  textDecoration: "none",
  "&:hover": { textDecoration: "underline" },
};
